import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth'
import {
  addLocalStorage,
  getLocalStorage,
  removeLocalStorage
} from '../../../infra/storage/localStorage'
import { setDefaultToken } from '../cookies'

export const getUser = () => {
  const user = getLocalStorage('user')
  if (user) {
    return JSON.parse(user)
  }
}

export const setUser = async (user: any) => {
  await addLocalStorage('user', JSON.stringify(user))
}

export const removeUser = () => {
  removeLocalStorage('user')
}

export async function isAuthenticatedUser () {
  try {
    await getCurrentUser()
    await refreshToken()
    return true
  } catch {
    return false
  }
}

export async function refreshToken () {
  try {
    const { tokens } = await fetchAuthSession()
    if (tokens?.idToken?.toString()) {
      setDefaultToken(tokens.idToken.toString())
    }
  } catch (error) {
    console.error('Error refreshing token:', error)
  }
}
